import { ITemplateModel, TemplateModel } from 'TemplateConstants/store/model'
import { IUserModel, UserModel } from './User'

export interface Model extends ITemplateModel {
  UserModel: IUserModel
}

export const model: Model = {
  ...TemplateModel,
  UserModel
}
